import { closeModal, openModal } from "../state/modalSlice";
import PhotoWatchModal from "../modals/photoWatch";
import store from "../state/store";

export const handleOpenDatailPhoto = (photo: string, title?: string) => {
  store.dispatch(
    openModal({
      component: PhotoWatchModal,
      context: {
        photoUrl: photo,
        title,
        closeModal: () => store.dispatch(closeModal()), // Закрыть модальное окно через Redux
      },
    })
  );
};
